import { Component, OnInit, Input } from "@angular/core";
import { FromToDetail } from "../../../../../_objects/report-element";
import { Notifier, OfflineReportPreviewService, MousePoint } from "../../../../../_services/offline-report-preview.service";
import { ReportISO } from "../../../../models/report-preview/report-iso";

@Component({
  selector: "app-report-iso",
  templateUrl: "./report-iso.component.html",
  styleUrls: ["./report-iso.component.scss"],
  standalone: false
})
export class ReportIsoOfflineComponent implements OnInit {
  @Input() pageKey: string;
  @Input() isoKey: string;
  @Input() public elementLocation: string;

  reportIso: ReportISO;
  private notifier: Notifier;

  readonly isoStyle =
    "position: absolute; width: 100%; height: 100%;  background-image: linear-gradient(-135deg, #14c05c 4.5px, transparent 0), linear-gradient(45deg, #14c05c 4.5px, transparent 0);";
  readonly imgStyle = "margin: 0; white-space: pre-wrap; height: auto;";
  constructor(public designService: OfflineReportPreviewService) {}

  ngOnInit() {
    this.notifier = {
      componentName: "report-iso.component",
      ids: { pageId: this.pageKey, elementId: this.isoKey }
    };
  }

  onClick(event: MouseEvent) {
    if (this.reportIso.isSelectable) {
      event.stopPropagation();
    }
  }

  onDragStart(event: DragEvent) {
    event.dataTransfer.setData("text", this.isoKey);
    event.dataTransfer.effectAllowed = "move";

    const fromDetail: FromToDetail = {
      location: this.reportIso.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const template = { ...this.designService.originTemplate };
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    const dragElemId = event.dataTransfer.getData("text");

    const toDetail: FromToDetail = {
      location: this.reportIso.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportIso.getLeftPx() + event.offsetX,
      onElementY: this.reportIso.getTopPx() + event.offsetY
    };

    event.dataTransfer.clearData("text");
    event.stopPropagation();
  }
}
